export enum ThemeSettings {
    buttonsSettings = 'buttonsSettings',
    colorsSettings = 'colorsSettings',
    fontsSettings = 'fontsSettings',
}
